/**
 * Where an active caller lands (f9.2).
 *
 * f1.1's landing was the constant `/dashboard`. From f9.1 a caller may not be
 * shown the dashboard, so the landing is COMPUTED -- and computed only from
 * the `navigation` array the server sent. It takes no role code and no scope
 * set: the server already narrowed the array, and this merely picks its first
 * entry in the declared information-architecture order.
 */

import { NAV_ENTRIES } from './navigation';

/**
 * The first `NAV_ENTRIES` path whose key the server permitted, or `null` when
 * it permitted none -- the caller then gets a landing STATE, not a route.
 */
export function landingPathFor(navigation: readonly string[]): string | null {
  const permitted = new Set(navigation);
  return NAV_ENTRIES.find((entry) => permitted.has(entry.key))?.path ?? null;
}

/**
 * Where a "take me somewhere useful" button points.
 *
 * `DEFAULT_ROUTE` survives, but only when it is itself permitted: a recovery
 * link that lands on a screen the caller cannot use is a dead end. The
 * dashboard is the FIRST entry of `NAV_ENTRIES`, so the computed landing is
 * `DEFAULT_ROUTE` exactly when the dashboard is permitted. With nothing
 * permitted, `/` renders the caller's landing state.
 */
export function recoveryPathFor(navigation: readonly string[]): string {
  return landingPathFor(navigation) ?? '/';
}
